import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.667 11.4c0 2.333-.934 3.267-3.267 3.267H4.6c-2.333 0-3.267-.934-3.267-3.267V8.6c0-2.333.934-3.267 3.267-3.267h2.8c2.333 0 3.267.934 3.267 3.267v2.8Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.667 7.4c0 2.333-.934 3.267-3.267 3.267h-.733V8.6c0-2.333-.934-3.267-3.267-3.267H5.333V4.6c0-2.333.934-3.267 3.267-3.267h2.8c2.333 0 3.267.934 3.267 3.267v2.8Z"
    />
  </svg>
)
export default SvgComponent
